export default "__VITE_ASSET__751b33c6__"